<template>
  <div>
    <ul id="data_menu">
      <li
        id="show_table"
        v-if="!core.showTable"
        @click="core.clickShowTable"
        :title="$t('common.title_table')"
      >
        <v-icon style="color: #e6e6e6">table_view</v-icon>
        {{ core.tableWidthSize != "xs" ? $t("common.table") : "" }}
        <v-icon style="color: #e6e6e6" v-if="!core.showTable"
          >arrow_drop_up</v-icon
        >
        <v-icon style="color: #e6e6e6" v-else>arrow_drop_down</v-icon>
      </li>
    </ul>

    <div id="data_container" ref="data_container" class="row" app>
      <v-btn
        v-if="core.showTable"
        @mousedown="core.tableSliderDrag($event)"
        small
        :title="$t('common.title_tableSliderDrag')"
        id="tableSlider"
        ref="tableSlider"
        fab
        @touchstart="core.tableSliderDrag($event)"
      >
        <v-icon>mdi-arrow-split-horizontal</v-icon>
      </v-btn>
      <div id="data_content">
        <div id="data_tools">
          <div id="data_tools_content" class="custom_v-container">
            <v-row>
              <v-col
                cols="12"
                :xs="core.tableWidthSize == 'xs' ? 12 : 6"
                :sm="core.tableWidthSize == 'xs' ? 12 : 6"
                :md="core.tableWidthSize == 'xs' ? 12 : 6"
                :lg="core.tableWidthSize == 'xs' ? 12 : 6"
                :style="
                  core.tableWidthSize == 'xs'
                    ? 'padding-top: 6px;padding-bottom: 6px;'
                    : ''
                "
              >
                <v-btn
                  :title="$t('common.title_tableClose')"
                  icon
                  dark
                  @click="core.clickShowTable"
                  ><v-icon x-large>arrow_drop_down</v-icon></v-btn
                >
                <v-btn
                  :title="$t('common.title_tableExtent')"
                  icon
                  dark
                  v-if="core.tableItems.length > 0"
                  @click="core.extentDrawnItemBounds"
                >
                  <v-icon>zoom_out_map</v-icon></v-btn
                >
                <v-btn
                  class="table-help"
                  icon
                  dark
                  text
                  @click.stop="core.tour2.runTableTourSteps()"
                  :title="$t('common.helpTitleTips')"
                >
                  <v-icon>mdi-help-circle</v-icon>
                </v-btn>
                &nbsp;<v-btn
                  class="table-add-record tour_table_step1"
                  small
                  dark
                  color="primaryButton"
                  :disabled="!core.enableIdentify"
                  @click="core.addBlankRecord()"
                >
                  <v-icon>add</v-icon>
                  <span
                    v-if="
                      core.tableWidthSize == 'lg' || core.tableWidthSize == 'xl'
                    "
                    >{{ $t("common.addBlankRecord") }}</span
                  > </v-btn
                >&nbsp;<v-btn
                  :disabled="!core.enableIdentify"
                  class="table-manage-columns tour_table_step2"
                  small
                  dark
                  @click="core.manageColumnModal = true"
                  color="primary"
                >
                  <v-icon>mdi-wrench</v-icon>
                  <span
                    v-if="
                      core.tableWidthSize == 'lg' || core.tableWidthSize == 'xl'
                    "
                    >{{ $t("common.manageColumns") }}</span
                  ></v-btn
                >&nbsp;<!-- Delete Table Record Button -->
                <v-btn
                  id="delete_table_all_records"
                  class="tour_table_step3"
                  :disabled="
                    !core.enableIdentify || core.tableItems.length == 0
                  "
                  small
                  dark
                  color="error"
                  @click="core.removeTableDatas"
                  ><v-icon>mdi-delete</v-icon>
                  <span
                    v-if="
                      core.tableWidthSize == 'lg' || core.tableWidthSize == 'xl'
                    "
                    >{{ $t("common.deletAllRecord") }}</span
                  > </v-btn
                >&nbsp;<!-- Filter Button -->
                <template v-if="core.tableWidthSize == 'xs'">
                  <v-badge
                    v-if="core.filterKeyword && core.filterKeyword.length > 0"
                    bordered
                    color="error"
                    :content="core.filterKeyword.length"
                    overlap
                  >
                    <v-btn
                      small
                      dark
                      color="warning"
                      @click="enabledFilter = !enabledFilter"
                    >
                      <v-icon v-if="enabledFilter">mdi-filter-minus</v-icon>
                      <v-icon v-else>mdi-filter-menu</v-icon>
                    </v-btn>
                  </v-badge>
                  <v-btn
                    v-else
                    small
                    dark
                    color="warning"
                    @click="enabledFilter = !enabledFilter"
                  >
                    <v-icon v-if="enabledFilter">mdi-filter-minus</v-icon>
                    <v-icon v-else>mdi-filter-menu</v-icon>
                  </v-btn>
                </template>
                &nbsp;
              </v-col>

              <v-col
                v-if="
                  core.tableWidthSize != 'xs' ||
                  (core.tableWidthSize == 'xs' && enabledFilter)
                "
                cols="12"
                :xs="core.tableWidthSize == 'xs' ? 12 : 6"
                :sm="core.tableWidthSize == 'xs' ? 12 : 6"
                :md="core.tableWidthSize == 'xs' ? 12 : 6"
                :lg="core.tableWidthSize == 'xs' ? 12 : 6"
                id="filterSearchrBar"
                ref="filterSearchrBar"
                :style="core.tableWidthSize == 'xs' ? 'padding-top: 0px;' : ''"
              >
                <!-- <b-form-group label="Filter" label-for="filterInput" label-cols-sm="1" label-cols-md="1" label-align-sm="right" class="mb-0" > -->
                <v-combobox
                  ref="tour_step3"
                  :label="$t('common.typeToSearch')"
                  :title="$t('common.title_filteSearchrBar')"
                  v-model="core.filterKeyword"
                  :items="filterCmd"
                  hide-selected
                  hide-details
                  append-icon
                  multiple
                  clearable
                  small-chips
                  deletable-chips
                  solo
                  dense
                  filled
                  @focus="resizeFilterItem()"
                >
                  <template v-slot:item="{ item }">
                    <template
                      v-if="
                        item.toUpperCase() ==
                          core.GLOBAL.FILTER_COMMEND.AUTOMATCHED.toUpperCase() ||
                        item.toUpperCase() ==
                          core.GLOBAL.FILTER_COMMEND.AUTOMATCHEDXY.toUpperCase() ||
                        item.toUpperCase() ==
                          core.GLOBAL.FILTER_COMMEND.NONGEOTAGGED.toUpperCase() ||
                        item.toUpperCase() ==
                          core.GLOBAL.FILTER_COMMEND.GEOTAGGED.toUpperCase()
                      "
                    >
                      <div
                        name="filterSearchrBarItem"
                        v-html="
                          item.toUpperCase() ==
                          core.GLOBAL.FILTER_COMMEND.AUTOMATCHED.toUpperCase()
                            ? $t('common.FILTER_COMMEND.AUTOMATCHED')
                            : item.toUpperCase() ==
                              core.GLOBAL.FILTER_COMMEND.AUTOMATCHEDXY.toUpperCase()
                            ? $t('common.FILTER_COMMEND.AUTOMATCHEDXY')
                            : item.toUpperCase() ==
                              core.GLOBAL.FILTER_COMMEND.NONGEOTAGGED.toUpperCase()
                            ? $t('common.FILTER_COMMEND.NONGEOTAGGED')
                            : item.toUpperCase() ==
                              core.GLOBAL.FILTER_COMMEND.GEOTAGGED.toUpperCase()
                            ? $t('common.FILTER_COMMEND.GEOTAGGED')
                            : ''
                        "
                      ></div>
                    </template>
                  </template>
                  <template v-slot:selection="{ index, item, attrs }">
                    <template
                      v-if="
                        item.toUpperCase() ==
                          core.GLOBAL.FILTER_COMMEND.AUTOMATCHED.toUpperCase() ||
                        item.toUpperCase() ==
                          core.GLOBAL.FILTER_COMMEND.AUTOMATCHEDXY.toUpperCase() ||
                        item.toUpperCase() ==
                          core.GLOBAL.FILTER_COMMEND.NONGEOTAGGED.toUpperCase() ||
                        item.toUpperCase() ==
                          core.GLOBAL.FILTER_COMMEND.GEOTAGGED.toUpperCase()
                      "
                    >
                      <v-chip
                        style="margin: 2px 0px"
                        :key="JSON.stringify(item)"
                        v-bind="attrs"
                        color="red"
                        dark
                      >
                        <span style="overflow: hidden"
                          >{{
                            item.toUpperCase() ==
                            core.GLOBAL.FILTER_COMMEND.AUTOMATCHED.toUpperCase()
                              ? $t("common.FILTER_COMMEND.AUTOMATCHED")
                              : item.toUpperCase() ==
                                core.GLOBAL.FILTER_COMMEND.AUTOMATCHEDXY.toUpperCase()
                              ? $t("common.FILTER_COMMEND.AUTOMATCHEDXY")
                              : item.toUpperCase() ==
                                core.GLOBAL.FILTER_COMMEND.NONGEOTAGGED.toUpperCase()
                              ? $t("common.FILTER_COMMEND.NONGEOTAGGED")
                              : item.toUpperCase() ==
                                core.GLOBAL.FILTER_COMMEND.GEOTAGGED.toUpperCase()
                              ? $t("common.FILTER_COMMEND.GEOTAGGED")
                              : ""
                          }}
                        </span>
                        <v-btn @click="removeChip(index)" small icon
                          ><v-icon small>close</v-icon></v-btn
                        >
                      </v-chip>
                    </template>
                    <template v-else>
                      <v-chip dark :key="JSON.stringify(item)" v-bind="attrs">
                        {{ item }}
                        <v-btn small @click="removeChip(index)" icon
                          ><v-icon small>close</v-icon></v-btn
                        >
                      </v-chip>
                    </template>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
          </div>
        </div>

        <b-table
          ref="table"
          hover
          show-empty
          :sort-by.sync="core.tableSortKey"
          :striped="true"
          :empty-text="$t('common.norecord')"
          :sort-compare="core.mySortCompare"
          :sticky-header="true"
          :no-border-collapse="true"
          :small="false"
          head-variant="dark"
          :fixed="false"
          :items="core.filteredItems"
          :tbody-tr-class="core.tableRowClass"
          :fields="core.fields"
          :current-page="core.currentPage"
          :per-page="core.perPage"
        >
          <template
            v-for="field in core.fields"
            v-slot:[`cell(${field.key})`]="data"
          >
            <template
              v-if="field.key === core.GLOBAL.HIDDEN_FIELD_LABELS.LATLNGS"
              ><div v-html="core.renderLatLngs(data)" :key="field.label"></div
            ></template>
            <template
              v-else-if="field.key === core.GLOBAL.HIDDEN_FIELD_LABELS.INDEX"
            >
              <div
                :key="field.label"
                class="rowheader"
                :index="data.item.index"
                @click="
                  core.updateCurrentSelectedTableItem({ tableItem: null });
                  core.zoomTo({
                    leaflet_id: data.item.leaflet_id,
                    ref_leaflet_id: data.item.refLayer
                      ? data.item.refLayer.leaflet_id
                      : null,
                    zoomIn: true,
                  });
                  core.updateCurrentSelectedTableItem({ tableItem: data.item });
                  core.$GA.t_click_table_item_zoom();
                "
              >
                <span class="selectedTableItemDynamicTextColor">{{
                  data.item.index
                }}</span>
                &nbsp;&nbsp;
                <v-btn
                  class="selectedTableItemDynamicTextColor2"
                  :disabled="!core.enableIdentify"
                  :title="$t('common.title_tableRemoveRecord')"
                  icon
                  small
                  :key="field.label + '_trash'"
                  @click.stop="core.removeTableDataByTableItem(data.item)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>

                <template v-if="data.item.leaflet_id == null">
                  <v-btn
                    class="selectedTableItemDynamicTextColor2"
                    :disabled="!core.enableIdentify"
                    :title="$t('common.title_addMarker')"
                    icon
                    color="blue"
                    @click.stop="
                      core.updateCurrentSelectedTableItem({
                        tableItem: data.item,
                      });
                      core.setShowTable({ val: false });
                      core.enableIdentifyTableItemMarker = true;
                    "
                    ><v-icon>mdi-map-marker-plus</v-icon></v-btn
                  >
                </template>
                <v-btn
                  :disabled="!core.enableIdentify"
                  :title="$t('common.title_tableAddLayer')"
                  icon
                  color="primary"
                  v-if="
                    !data.item.hasOwnProperty('refLayer') &&
                    core.enableAttachRefLayer
                  "
                  @click.stop="
                    core.updateCurrentSelectedTableItem({
                      tableItem: data.item,
                    });
                    core.enableAddLayerReference(data.item);
                    core.enableIdentifyTableItemSubLayer = true;
                  "
                  ><v-icon>mdi-layers-plus</v-icon></v-btn
                >
                <v-btn
                  :disabled="!core.enableIdentify"
                  :title="$t('common.title_tableRemoveLayer')"
                  v-else-if="core.enableAttachRefLayer"
                  icon
                  color="red"
                  @click.stop="
                    core.updateCurrentSelectedTableItem({
                      tableItem: data.item,
                    });
                    core.unattachRefLayerData();
                    core.enableIdentifyTableItemSubLayer = false;
                  "
                  ><v-icon>mdi-layers-off</v-icon></v-btn
                >
                <div
                  class="tableItemXYContainer"
                  v-if="core.getXYByLeafletId(data.item.leaflet_id)"
                >
                  <div
                    class="
                      tableItemXYContainerTitle
                      selectedTableItemDynamicTextColor2
                    "
                    style="white-space: nowrap"
                  >
                    {{ $t("common.latitude") + "," + $t("common.longitude") }}:
                  </div>
                  <div
                    class="selectedTableItemDynamicTextColor"
                    style="white-space: nowrap"
                  >
                    {{
                      core.displayXY(
                        core.getXYByLeafletId(data.item.leaflet_id)
                      ).lat +
                      ", " +
                      core.displayXY(
                        core.getXYByLeafletId(data.item.leaflet_id)
                      ).lng
                    }}
                  </div>
                  <div
                    class="
                      tableItemXYContainerTitle
                      selectedTableItemDynamicTextColor2
                    "
                    style="white-space: nowrap"
                  >
                    {{ $t("common.hk80y") + "," + $t("common.hk80x") }}:
                  </div>
                  <div
                    class="selectedTableItemDynamicTextColor"
                    style="white-space: nowrap"
                  >
                    {{
                      core.displayHK80(
                        core.getXYByLeafletId(data.item.leaflet_id)
                      )[1] +
                      ", " +
                      core.displayHK80(
                        core.getXYByLeafletId(data.item.leaflet_id)
                      )[0]
                    }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                :key="field.label"
                class="editable_field"
                @click="
                  core.updateCurrentSelectedTableItem({ tableItem: data.item });
                  core.zoomTo({ leaflet_id: data.item.leaflet_id });
                "
              >
                <v-menu
                  v-model="
                    core.datePickerMenuModel[data.item.index + '_' + field.key]
                  "
                  v-if="data.field.type == core.GLOBAL.FIELD_TYPES.DATE"
                  label="Picker in menu"
                  transition="scale-transition"
                  :close-on-content-click="false"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div style="display: flex; flex-direction: row-reverse">
                      <v-icon
                        @click="
                          core._setValueFromItems(data.item, field, '');
                          core.datePickerMenuModel[
                            data.item.index + '_' + field.key
                          ] = false;
                          core.datePickerMenuModel[
                            data.item.index + '_' + field.key + '_value'
                          ] = '';
                        "
                        >clear</v-icon
                      >
                      <v-text-field
                        class="selectedTableItemDynamicTextColor"
                        :value="core._getValueFromItems(data.item, field)"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        prepend-icon="mdi-calendar"
                      ></v-text-field>
                    </div>
                  </template>
                  <v-date-picker
                    class="selectedTableItemDynamicTextColor"
                    :locale="locate == 'en' ? '' : 'zh'"
                    v-model="
                      core.datePickerMenuModel[
                        data.item.index + '_' + field.key + '_value'
                      ]
                    "
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      @click="
                        core.datePickerMenuModel[
                          data.item.index + '_' + field.key
                        ] = false;
                        core.datePickerMenuModel[
                          data.item.index + '_' + field.key + '_value'
                        ] = core._getValueFromItems(data.item, field);
                        $forceUpdate();
                      "
                      >{{ $t("common.cancel") }}</v-btn
                    >
                    <v-btn
                      color="primary"
                      @click="
                        core.datePickerMenuModel[
                          data.item.index + '_' + field.key
                        ] = false;
                        core._setValueFromItems(
                          data.item,
                          field,
                          core.datePickerMenuModel[
                            data.item.index + '_' + field.key + '_value'
                          ]
                        );
                      "
                      >{{ $t("common.ok") }}</v-btn
                    >
                  </v-date-picker>
                </v-menu>
                <div
                  style="display: flex; flex-direction: row"
                  v-else-if="
                    data.field.type == core.GLOBAL.FIELD_TYPES.TEXTAREA ||
                    data.field.type == core.GLOBAL.FIELD_TYPES.ADDRESS_ZH ||
                    data.field.type == core.GLOBAL.FIELD_TYPES.ADDRESS_EN
                  "
                  @mouseleave="core.currentSelectedTableItemColumn = null"
                  @mouseover="
                    core.currentSelectedTableItemColumn =
                      'tableItemField_' + data.item.index + '_' + field.key
                  "
                >
                  <textarea
                    :class="`selectedTableItemDynamicTextColor ${
                      core._getValueFromItems(data.item, data.field) != null &&
                      core._getValueFromItems(data.item, data.field) !== ''
                        ? 'contain_content'
                        : ''
                    }`"
                    :name="
                      'tableItemField_' + data.item.index + '_' + field.key
                    "
                    :placeholder="$t('common.empty')"
                    @keyup="
                      core.currentSelectedTableItemColumn =
                        'tableItemField_' + data.item.index + '_' + field.key;
                      core.updateTableDataByListener(data, $event);
                    "
                    @input="core.updateTableDataByListener(data, $event)"
                    :value="core._getValueFromItems(data.item, data.field)"
                  ></textarea>
                  <v-btn
                    :style="`visibility: ${
                      core.currentSelectedTableItemColumn ==
                      'tableItemField_' + data.item.index + '_' + field.key
                        ? 'visible'
                        : 'hidden'
                    } `"
                    class="selectedTableItemDynamicTextColor2"
                    icon
                    :title="$t('common.title_tableItemInputSearchButton')"
                    @click.stop="
                      core.updateCurrentSelectedTableItem({
                        tableItem: data.item,
                      });
                      core.$GA.t_click_table_item_search_location();
                      core.searchBar.ignoreShowSearchBarMenu = true;
                      core.searchBar.searchKeywordModel =
                        core._getValueFromItems(data.item, data.field);
                      core.searchBar.fetchPlaces(
                        core._getValueFromItems(data.item, data.field)
                      );
                    "
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                </div>
                <input
                  class="selectedTableItemDynamicTextColor"
                  v-else
                  :type="
                    data.field.type == core.GLOBAL.FIELD_TYPES.TEXT
                      ? 'text'
                      : data.field.type == core.GLOBAL.FIELD_TYPES.NUMBER
                      ? 'number'
                      : 'text'
                  "
                  :placeholder="$t('common.empty')"
                  @keyup="
                    core.currentSelectedTableItemColumn =
                      'tableItemField_' + data.item.index + '_' + field.key;
                    core.updateTableDataByListener(data, $event);
                  "
                  @input="core.updateTableDataByListener(data, $event)"
                  :value="core._getValueFromItems(data.item, data.field)"
                />
              </div>
            </template>
          </template>
        </b-table>

        <v-divider class="pa-0 ma-0"></v-divider>

        <div class="custom_v-container">
          <v-row>
            <v-col cols="2" xs="2" sm="3" md="3" lg="3" class="pb-0">
              <template
                v-if="
                  core.tableWidthSize != 'xs' && core.tableWidthSize != 'sm'
                "
              >
                <span class="caption">{{
                  $t("common.selectedTableId") + ": "
                }}</span>
                <span class="caption">
                  {{
                    core.currentSelectedTableItem
                      ? "#" + core.currentSelectedTableItem.index
                      : $t("common.none")
                  }}
                </span>
                <v-btn
                  small
                  dark
                  class="caption"
                  :disabled="
                    !core.enableIdentify || !core.currentSelectedTableItem
                  "
                  @click="
                    core.updateCurrentSelectedTableItem({ tableItem: null })
                  "
                  >{{ $t("common.clear") }}
                </v-btn>
              </template>

              <template v-else>
                <v-btn
                  x-small
                  dark
                  class="caption"
                  :disabled="
                    !core.enableIdentify || !core.currentSelectedTableItem
                  "
                  @click="
                    core.updateCurrentSelectedTableItem({ tableItem: null })
                  "
                >
                  <v-icon small>check_box</v-icon>
                  {{
                    core.currentSelectedTableItem
                      ? "#" + core.currentSelectedTableItem.index
                      : $t("common.none")
                  }}
                </v-btn>
              </template>
            </v-col>

            <v-col
              v-if="core.tableWidthSize != 'xs'"
              cols="2"
              xs="2"
              sm="2"
              md="2"
              lg="2"
              align="right"
              class="pb-0 pr-0"
            >
              <span class="caption">{{ currentItemsOnPage }}</span>
            </v-col>

            <v-col cols="7" xs="7" sm="5" md="5" lg="5" class="pb-0 pl-0">
              <b-pagination
                v-model="core.currentPage"
                :total-rows="core.totalRows"
                :per-page="core.perPage"
                style="max-width: 400px"
                size="sm"
                align="fill"
              >
                <template #first-text
                  ><v-icon small color="primary"
                    >mdi-chevron-double-left</v-icon
                  ></template
                >
                <template #prev-text
                  ><v-icon small color="primary"
                    >mdi-chevron-left</v-icon
                  ></template
                >
                <template #next-text
                  ><v-icon small color="primary"
                    >mdi-chevron-right</v-icon
                  ></template
                >
                <template #last-text
                  ><v-icon small color="primary"
                    >mdi-chevron-double-right</v-icon
                  ></template
                >
              </b-pagination>
            </v-col>

            <v-col cols="3" xs="3" sm="2" md="2" lg="2" class="pb-0 pl-0">
              <v-select
                class="caption"
                v-model="core.perPage"
                hide-details
                :items="core.pageOptions"
                dense
                solo
              >
                <template
                  v-slot:selection="{ item }"
                  v-if="
                    core.tableWidthSize != 'xs' && core.tableWidthSize != 'sm'
                  "
                >
                  {{ $t("common.perPage") }}:&nbsp;&nbsp;{{ item }}
                </template>
                <template v-slot:selection="{ item }" v-else>
                  <v-icon>mdi-text-box-multiple-outline</v-icon>&nbsp;&nbsp;{{
                    item
                  }}
                </template>
              </v-select>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>

    <v-dialog
      scrollable
      v-model="core.manageColumnModal"
      maxWidth="90%"
      width="500"
      :style="`z-index: ${this.core.leftBarIndex};position: fixed;`"
      id="manageColumnModal"
      ref="manageColumnModal"
      :persistent="true"
    >
      <v-card>
        <v-toolbar dark color="primary">
          {{ $t("common.manageColumns") }}
          <v-spacer></v-spacer
          ><v-btn icon @click.stop="core.tour2.runColumnSettingsTourSteps()"
            ><v-icon>mdi-help-circle</v-icon></v-btn
          >
          <v-btn icon @click="core.manageColumnModal = false"
            ><v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-row class="tour_columnsettings_step4">
            <v-col class="text-center pl-6 pr-6" id="layer-name">
              <v-text-field
                v-model="layerName"
                outlined
                :label="$t('common.tableColumnLayerName')"
                :rules="[core.rules.required, filterLayerName]"
                @change="updateLayerName"
              />
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-title>
          <v-row>
            <v-col
              xs="5"
              sm="4"
              md="4"
              style="padding-left: 0px; padding-right: 0px"
            >
              <v-icon>format_list_numbered</v-icon>
              <span v-if="$vuetify.breakpoint.name != 'xs'" class="caption">
                {{ $t("common.sortableList") }}
              </span>
            </v-col>
            <v-col xs="7" sm="8" md="8" align="right" justify="right">
              <v-btn
                class="tour_columnsettings_step1"
                small
                color="error"
                @click="core.removeAllColumns()"
                >{{ $t("common.removeAllColumns") }}</v-btn
              ></v-col
            >
          </v-row>
        </v-card-title>
        <v-card-text id="col-manage">
          <v-container
            fluid
            grid-list-md
            text-xs-center
            class="column_managment_container tour_columnsettings_step2"
          >
            <v-layout row wrap>
              <v-flex xs12 md12>
                <div class="col-img"></div>

                <template v-if="enableColumnSettingsExample">
                  <v-img :src="`./img/col_set_tour.png`" style="width: 100%" />
                </template>

                <template v-else-if="core.dynamicFields.length == 0">
                  <p class="text-center no_record">
                    {{ $t("common.nocolumnMessage") }}
                  </p>
                </template>

                <div v-else class="draggable_list">
                  <template v-for="(dynamicField, index) in core.dynamicFields">
                    <div
                      :ref="index"
                      :class="
                        core.detectIEBrowser() == ''
                          ? 'draggable_item_container'
                          : 'draggable_item_container non_move'
                      "
                      v-if="core.isNotHiddenField(dynamicField.label)"
                      :key="dynamicField.key"
                      @dragover.prevent
                      @dragenter.prevent
                      @drop="
                        core.onDynamicFieldDrop($event, dynamicField, index)
                      "
                      :draggable="core.detectIEBrowser() == '' ? true : false"
                      @dragstart="core.startDynamicFieldDrag($event, index)"
                    >
                      <v-layout row wrap>
                        <v-flex xs12 md12>
                          <v-layout row wrap class="draggable_item_content">
                            <v-flex xs2 sm2 md2 lg2 center
                              ><v-avatar color="grey"
                                ><span class="white--text">{{
                                  index + 1
                                }}</span></v-avatar
                              >
                            </v-flex>

                            <v-flex xs6 sm6 md6 lg6 center>
                              <EditField
                                ref="editfield"
                                :rules="core.rules"
                                :isPopped="core.manageColumnModal"
                                :existedColumnList="core.exportGmlColumnExistedList"
                                :invalidNameList="core.exportGmlInvalidNameList"
                                :dynamicField="dynamicField"
                                :updateDynamicFieldItem="
                                  core.updateDynamicFieldItem
                                "
                                :isExistingDynamicField="
                                  core.isExistingDynamicField
                                "
                                @updateInput="onColumnsUpdated"
                              />
                            </v-flex>

                            <v-flex xs4 sm4 md4 lg4 center>
                              <v-btn
                                icon
                                :title="
                                  $t('common.title_manageColumnsRemoveColumn')
                                "
                                @click="core.removeColumnData(dynamicField)"
                                ><v-icon>mdi-delete</v-icon></v-btn
                              >

                              <v-btn
                                :title="$t('common.title_switchLayerUp')"
                                icon
                                @click="
                                  core.updateDynamicFieldItemIndex(
                                    dynamicField,
                                    index,
                                    'up'
                                  )
                                "
                                ><v-icon>mdi-arrow-up-bold</v-icon></v-btn
                              >

                              <v-btn
                                :title="$t('common.title_switchLayerDown')"
                                icon
                                @click="
                                  core.updateDynamicFieldItemIndex(
                                    dynamicField,
                                    index,
                                    'down'
                                  )
                                "
                                ><v-icon>mdi-arrow-down-bold</v-icon></v-btn
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container>
            <v-row class="tour_columnsettings_step3">
              <v-col cols="8" class="text-center pr-0">
                <v-form
                  ref="newColumnNameForm"
                  @submit.prevent="core.returnFalse"
                >
                  <v-text-field
                    class="col-new"
                    id="newColumnName"
                    outlined
                    v-model="core.newColumnName"
                    :label="$t('common.newColumnName')"
                    :rules="[
                      core.rules.newColumnNameRequired,
                      core.validNewColumnNameState,
                    ]"
                    @keyup.enter.native="core.handleSubmit"
                  ></v-text-field>
                </v-form>
              </v-col>

              <v-col cols="4" class="text-center">
                <v-btn
                  class="col-add"
                  color="primary"
                  large
                  @click="core.handleSubmit"
                  :disabled="
                    typeof core.validNewColumnNameState === 'string' ||
                    !core.validNewColumnNameState
                  "
                  >{{ $t("common.add") }}</v-btn
                >
              </v-col>
            </v-row>

            <v-row class="mt-0">
              <v-col cols="12" class="pt-0">
                <v-btn
                  dark
                  large
                  block
                  @click="core.manageColumnModal = false"
                  color="primary"
                  >{{ $t("common.close") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EditField from "./EditField.vue";
import $ from "jquery";

export default {
  components: {
    EditField,
  },
  props: ["core"],
  data() {
    return {
      enabledFilter: false,
      enableColumnSettingsExample: false,
      requireUpdateColumns: false,
      layerName: "",
    };
  },

  watch: {
    [`core.filterKeyword`]() {
      this.resizeFilterItem();
    },
  },

  computed: {
    currentItemsOnPage() {
      // console.log(this.core.perPage,this.core.totalRows )
      if (
        this.core.filteredItems.length > 1 &&
        this.core.totalRows / this.core.perPage > 0
      ) {
        return (
          String((this.core.currentPage - 1) * this.core.perPage + 1) +
          "-" +
          String(
            this.core.currentPage * this.core.perPage > this.core.totalRows
              ? this.core.totalRows
              : this.core.currentPage * this.core.perPage
          ) +
          ` ${this.$t("common.tableOf")} ` +
          this.core.totalRows
        );
      } else return "";
    },
    filterCmd() {
      return [
        this.core.GLOBAL.FILTER_COMMEND.NONGEOTAGGED,
        this.core.GLOBAL.FILTER_COMMEND.GEOTAGGED,
        this.core.GLOBAL.FILTER_COMMEND.AUTOMATCHED,
        this.core.GLOBAL.FILTER_COMMEND.AUTOMATCHEDXY,
      ];
    },
    filterLayerName() {
      return this.layerName.match('^[^a-zA-Z_]+|[^a-zA-Z0-9_]+') == null || this.$t('common.tableColumnXmlStandard');
    }
  },
  mounted() {
    let me = this,
      stillResizeTimer = null;
    //   ,stillResizeTimer2 = null;

    window.addEventListener("resize", function () {
      setTimeout(() => {
        let data_container = $("#data_container");

        if (data_container.length > 0) {
          let tableWidth = data_container.width();
          if (tableWidth >= 1904) {
            me.core.tableWidthSize = "xl";
          } else if (tableWidth >= 1264) {
            me.core.tableWidthSize = "lg";
          } else if (tableWidth >= 960) {
            me.core.tableWidthSize = "md";
          } else if (tableWidth >= 600) {
            me.core.tableWidthSize = "sm";
          } else {
            me.core.tableWidthSize = "xs";
          }
        } else {
          me.core.tableWidthSize = "xs";
        }
      }, 50);

      // run resize searchBar
      clearTimeout(stillResizeTimer);
      stillResizeTimer = setTimeout(() => {
        me.core.$refs.searchBar.updateSearchBarWidth();
        me.resizeFilterItem();
      }, 100);
    });
  },
  methods: {
    updateLayerName(v){
      if (v) this.core.layerName = v;
    },
    resizeFilterItem2() {
      try {
        let searchbar = $("#filterSearchrBar");
        let filterSearchrBarItems = $("[name='filterSearchrBarItem']");

        for (let i = 0; i < filterSearchrBarItems.length; i++) {
          // console.log(filterSearchrBarItems[i], searchbar.clientWidth);
          filterSearchrBarItems[i].style.width =
            searchbar.clientWidth - 16 * 4 + "px";
          $(filterSearchrBarItems[i]).css(
            "width",
            searchbar.width() - 16 * 4 + "px"
          );
        }

        if (searchbar && searchbar.length > 0) {
          $("[name='filterSearchrBarItem']")
            .closest(".v-menu__content")
            .css("left", searchbar.offset().left + 16);
        }
      } catch (e) {
        if (process.env.NODE_ENV == "development") {
          console.log(e);
        }
      }
    },

    resizeFilterItem() {
      let me = this;
      this.resizeFilterItem2();
      setTimeout(() => {
        me.resizeFilterItem2();
      }, 100);
      // });
    },
    removeChip(index) {
      this.core.filterKeyword.splice(index, 1);
    },

    async onColumnsUpdated() {
      this.core.exportGmlColumnExistedList = this.core.checkDuplicatedFieldname();
    }
  },
};
</script>